/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Table, Input, Empty, Typography, Select } from 'antd'
// import './index.scss'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { getAge } from '../../../constants/helper'
import {
	CIVIL_STATUS,
	RESIDENCY_OWNERSHIP,
	RELATION_IN_HEAD,
	EDUCATIONAL_ATTAINMENT,
	DISABILITY_TYPE,
	OCCUPATION_CODE,
	INDUSTRY_CODE,
	CLASS_WORKER,
	NATURE_EMPLOYMENT,
	ILLNESSES,
	RESPIRATORY_ISSUES,
	REASON_NOT_APPLYING_JOB,
	GENERIC_LOOKUP
} from '../../../constants/lookup'

import ConstituentAvatar from '../../../components/Custom/ConstituentAvatar'
import SubscribeProgress from '../subscribeProgress'
import ViewDetails from '../../Certificates/modalDetails'

const { Title } = Typography

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isExporting: false,
			exportProgress: null,
			isViewDetails: false,
			selectedConstituent: null,
			customFilter: {}
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isExporting, exportProgress, isViewDetails, selectedConstituent,
			customFilter
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName, customFilter
		}
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row style={{
						padding: 20,
						marginBottom: 20,
						borderRadius: 10
					}}
						className='report-box'
					>
						<Title level={4}>Filters</Title>
						<Row gutter={16}>
							<Col md={6} sm={24}>
								<Select
									allowClear
									style={{ width: '100%' }}
									placeholder='Select Gender'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { gender: value }) })
									}}
								>
									<Select.Option value='Male'>Male</Select.Option>
									<Select.Option value='Female'>Female</Select.Option>
									<Select.Option value='Gay'>Gay</Select.Option>
									<Select.Option value='Bisexual'>Bisexual</Select.Option>
									<Select.Option value='Transgender'>Transgender</Select.Option>
									<Select.Option value='Lesbian'>Lesbian</Select.Option>
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select Civil Status'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { civil_status: value }) })
									}}
								>
									{
										CIVIL_STATUS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select Residency'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { residency_ownership: value }) })
									}}
								>
									{
										RESIDENCY_OWNERSHIP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%' }}
									placeholder='Select Household Role'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { relation_in_head: value }) })
									}}
								>
									{
										RELATION_IN_HEAD.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Educational Attainment'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { educational_attainment: value }) })
									}}
								>
									{
										EDUCATIONAL_ATTAINMENT.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Disability'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { disability_type: value }) })
									}}
								>
									{
										DISABILITY_TYPE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Occupation'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { occupation_code: value }) })
									}}
								>
									{
										OCCUPATION_CODE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Industry'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { industry_code: value }) })
									}}
								>
									{
										INDUSTRY_CODE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Class of worker'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { class_of_worker: value }) })
									}}
								>
									{
										CLASS_WORKER.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Nature of Employment'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { nature_of_employment: value }) })
									}}
								>
									{
										NATURE_EMPLOYMENT.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Type of Chronic disease'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { illness: value }) })
									}}
								>
									{
										ILLNESSES.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Type of Respiratory Issue'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { respiratory_issue: value }) })
									}}
								>
									{
										RESPIRATORY_ISSUES.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Select Reason not applying job'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { reason_not_looking_job: value }) })
									}}
								>
									{
										REASON_NOT_APPLYING_JOB.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Registered Voter'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { registered_voter: value }) })
									}}
								>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Member of 4Ps'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { member_4ps: value }) })
									}}
								>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							</Col>
							<Col md={6} sm={24}>
								<Select 
									allowClear
									style={{ width: '100%', marginTop: 15 }}
									placeholder='Deceased'
									onChange={(value) => {
										this.setState({ customFilter: Object.assign({}, this.state.customFilter, { deceased: value }) })
									}}
								>
									<Select.Option value='Yes'>Yes</Select.Option>
									<Select.Option value='No'>No</Select.Option>
								</Select>
							</Col>
						</Row>
					</Row>
					<Row>
						<Col md={6} sm={24}>
							<button 
								type="button" 
								className="btn btn-outline-success btn-rounded waves-effect waves-light"
								onClick={() => {
									const { exportConstituents } = this.props
									const params = {
										// date_start: moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
										// date_end: moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
										searchText,
										customFilter
									}
									exportConstituents(params)
								}}
							>
								<i className='mdi mdi-file-excel'/> Export in Excel
							</button>
						</Col>
						<Col md={18} sm={24}>
							<Row style={{ textAlign: 'right' }}>
								<Input 
									style={{ width: 300 }}
									placeholder='Search Here..' 
									onChange={(e)=>{
										this.setState({ searchText: e.target.value })
									}}/>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_CONSTITUENTS} 
							variables={{ 
								searchFilter: filters, 
								barangay_uid, 
								household_uid: null
							}}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let constituents = _.has(data,'allBarangayConstituents') ? data.allBarangayConstituents.data : []
								constituents = constituents.map((constituent, key) => Object.assign({}, constituent, { key }))
								let _pagination = _.has(data, 'allBarangayConstituents') ? data.allBarangayConstituents.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								let columns = [ {
									 	title: '#',
									 	key: 'avatar',
									width: 110,
									align: 'center',
									 	render: (record) => {
											 return <ConstituentAvatar size={75} constituent_uid={record.uid} />
									}
								}, {
									title: 'HH No.',
									 	dataIndex: 'household_no',
									 	key: 'household_no',
									 	width: 100,
									align: 'center'
								}, {
									 	title: 'First Name',
									 	dataIndex: 'first_name',
									 	key: 'first_name',
									 	width: 170
								}, {
									title: 'Middle Name',
									dataIndex: 'middle_name',
									key: 'middle_name',
									 	width: 170
								}, {
									title: 'Last Name',
									dataIndex: 'last_name',
									key: 'last_name',
									 	width: 170
								}, {
									title: 'Household Type',
									dataIndex: 'relation_in_head',
									key: 'relation_in_head',
									 	width: 150
								}, {
									title: 'Gender',
									dataIndex: 'gender',
									key: 'gender',
									 	width: 150
								}, {
									title: 'Birthday',
									key: 'birthday',
									 	width: 150,
									render: (record) => (
										<span>{moment(record.birthday).format('LL')}</span>
									)
								}, {
									title: 'Age',
									key: 'age',
									 	width: 70,
									render: (record) => (
										<span>{getAge(record.birthday)}</span>
									)
								}, {
									title: 'Purok',
									dataIndex: 'purok_name',
									key: 'purok_name',
									width: 100
								}, {
									title: 'Action',
									key: 'action',
									width: 150,
									render: (record) => {
										return (
											<a href='javascript:void(0)' onClick={() => {
												this.setState({ isViewDetails: true, selectedConstituent: record })
											}}>View Full Details</a>
										)
									}
								}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'constituents' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={constituents} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Col>
				{
					isViewDetails &&
					<ViewDetails 
						constituent_uid={selectedConstituent.uid}
						visible={isViewDetails}
						onCancel={() => this.setState({ isViewDetails: false, selectedConstituent: null })}
					/>
				}
			</Row>
		)
	}
}

const BARANGAY_CONSTITUENTS = gql`
    query allBarangayConstituents($barangay_uid: String, $household_uid: String, $searchFilter: SearchParams) {
		allBarangayConstituents(barangay_uid: $barangay_uid, household_uid: $household_uid, searchFilter: $searchFilter)
    }
`

const EXPORT_CONSTITUENTS = gql`
    mutation exportConstituents($input: JSON) {
		exportConstituents(input: $input)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_CONSTITUENTS, {
		props({ mutate }) {
			return {
				exportConstituents(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
